import React from "react";
import { useLang } from "@/context/LanguageContext";

export const StaffLangToggle = ({ dark = true }) => {
  const { lang, toggle } = useLang();
  return (
    <button onClick={toggle} data-testid="staff-lang-toggle" aria-label={lang === "ar" ? "Switch to English" : "التبديل إلى العربية"}
      className={`min-h-[40px] px-3 text-sm font-medium rounded-full border transition-colors ${dark ? "border-white/40 text-white hover:bg-white/10" : "border-[#141110] text-[#141110] hover:bg-[#141110]/5"}`}>
      {lang === "ar" ? "English" : "العربية"}
    </button>
  );
};
